<template>
    <div>
        <div class="wrapper text text--align-center">
            <div class="box box--yoga">
                <div class="box__background-width" style="left: 10%;"></div>
            </div>
            <span class="text text--big text--red number">
                <span id="shakeCountElem">00</span>
            </span>
            <p class="text text--red margin margin--bottom-20 text-info">
                <span v-html="currentData.copyRed"></span> <br>
                <span id="afterFirstActionCorrect" style="display: none;" v-html="currentData.copyRedAfterFirstCorrect"></span>
            </p>
            <button class="button" disabled="disabled" id="nextButton" v-if="stock">
                <router-link :to="'/activityType/' + this.$route.params.id + '/form'">{{currentData.buttonCopy}}</router-link>
            </button>
            <button class="button button-home" disabled="disabled" id="nextButton" v-if="!stock">
                <router-link :to="'/'">ZURÜCK ZUR STARTSEITE</router-link>
            </button>
            <svg width="0" height="0">
                <defs>
                    <clipPath id="volume">
                        <path d="M159.829,0 C169.60933,24.4370496 175,51.135796 175,79.1035354 C175,107.071275 169.60933,133.770021 159.829,158.207071 L141.414141,152.171163 C150.742356,129.312162 155.632891,104.58244 155.632891,79.1035354 C155.632891,53.6246307 150.742356,28.8949084 141.414141,6.03590806 L159.829,0 Z"
                              id="Shape" fill-opacity="0.25" fill="#817E65"></path>
                        <path d="M113.306498,15.0252525 C121.72955,34.6951117 126.388889,56.3536638 126.388889,79.1035354 C126.388889,101.853407 121.72955,123.511959 113.306498,143.181818 L94.5707071,137.086691 C102.456086,119.355546 106.838758,99.7349193 106.838758,79.1027894 C106.838758,58.4706595 102.456086,38.8500328 94.5707071,21.1188882 L113.306498,15.0252525 Z"
                              id="Shape" fill="#C60219"></path>
                        <path d="M66.7142618,30.0505051 C73.799487,44.7846746 77.7777778,61.2690786 77.7777778,78.6616162 C77.7777778,96.0541537 73.799487,112.538558 66.7142618,127.272727 L47.7272727,121.178439 C54.3361866,108.405957 58.0511141,93.9470465 58.0511141,78.6616162 C58.0511141,63.3761858 54.3361866,48.9180176 47.7272727,36.1447932 L66.7142618,30.0505051 Z"
                              id="Shape" fill="#C60219"></path>
                        <path d="M19.1181686,45.0757576 C24.932799,54.8886667 28.2828283,66.3831482 28.2828283,78.6616162 C28.2828283,90.9400841 24.932799,102.434566 19.1181686,112.247475 L0,105.961383 C5.62147292,98.3367605 8.95528283,88.8825869 8.95528283,78.6616162 C8.95528283,68.4406455 5.62147292,58.9864718 1.30960549e-15,51.3618489 L19.1181686,45.0757576 Z"
                              id="Shape" fill="#C60219"></path>
                    </clipPath>
                </defs>
            </svg>
        </div>
    </div>
</template>
<script>

    import data from '../assets/data/data'
    import sketch4 from '../../sketch4';
    import config from '../assets/data/config.json';
    import axios from 'axios';


    export default {
        name: 'GameYoga',

        data: function () {
            return {
                data: data,
                stock: false,
                availableData:  {
                    yoga: {
                        availableCount: 0
                    },
                    workout: {
                        availableCount: 0
                    },
                    running: {
                        availableCount: 0
                    }
                }
            }
        },
        mounted: function(){

            axios.get(config.endpoint.available).then(response => {

                if(response.data.availableData){
                    this.availableData = response.data.availableData;
                }
                this.checkAvailableProducts();


            }).catch((e) => {

            });
            var _this = this;

            if(!window.p5Instance){
                window.p5Instance = new window.p5();
                var e = document.createEvent('HTMLEvents');
                e.initEvent('click', false, true);
                document.dispatchEvent(e);
            }

            window.addEventListener('permissionDeniedMicEvent', _this.onPerm, false);

        },
        methods: {

            onPerm: function(){
                this.$router.push({ path: '/alert' });
            },
            checkAvailableProducts: function () {

                const allProducts = this.availableData;
                const emptyProducts = Object.keys(allProducts).filter(keyName => {
                    let currentValue = allProducts[keyName];
                    return currentValue.availableCount < 1
                });

                if(emptyProducts.length == Object.keys(allProducts).length) {

                } else {
                    this.stock = true;
                }

            }

        },
        computed: {
            currentData: function () {
                return this.data.activities[this.$route.params.id].game;
            },

        },
        beforeDestroy: function(){

            var _this = this;

            try {
                window.remove();
                window.p5Instance = undefined;
            } catch(e){}

            window.removeEventListener('permissionDeniedMicEvent', _this.onPerm);

        }
    }

</script>
<style lang="scss" scope="local">
    .box.box--yoga {

        position: relative;
        width: 175px;
        height: 160px;

        margin: auto;
        -webkit-clip-path: url(#volume);
        clip-path: url(#volume);

        background-color: #e1e2dc;
        margin-bottom: 20px;
        margin-top: 60px;
        transform: translateZ(0) scale(1.2);

        .box__background-width {
            transition: left .6s;
            will-change: left;
            -webkit-transform: translate3d(-100%, 50%, 0);
        }

    }
</style>

